import React, {Fragment, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import DatosTercero from './contactoTercero'
import {LoadingComponent}from 'recupero-comunes'
import { isValidParam } from '../../../../common/Formatos';

const ContactoTerceroModal = ({showContacto, handleCloseContacto}) => {
    const [loading, setLoading]=useState(false)
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves, datosGestionImplicado } = data_gestion_defensa;

    const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
   const { datosUltimoContacto, isModoContactoGlobal, loadingGlobal} = data_modal_contacto
    
    const [showToast, setShowToast] = React.useState(false);
    const [isHistorial, setIsHistorial] = React.useState(false)
    const [ultimaInstancias, setUltimaInstancias] = React.useState("")
    const dispatch = useDispatch()
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 

   useEffect(()=>{
    setUltimaInstancias(datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] && 
        isValidParam(datosUltimoContacto.datosUltimoContacto[0]['instancias']) ? datosUltimoContacto.datosUltimoContacto[0]['instancias'] : '')        
   },[datosUltimoContacto])
    useEffect(() => {
     
    }, [dispatch,llaves,datosGestionImplicado])
    
    return (
        <>
        <LoadingComponent show={loadingGlobal} />
            <Modal show={showContacto} onHide={handleCloseContacto} size='xl'>                
                <DatosTercero
                    ultimaInstancias={ultimaInstancias}
                    showToast={showToast}
                    setShowToast={setShowToast}
                    handleCloseContacto={handleCloseContacto}
                    handleShowToast={handleShowToast}
                />                
            </Modal>
        </>
    )
}

export default ContactoTerceroModal
